// extracted by mini-css-extract-plugin
export var chatHtmlText = "_r9-2";
export var chatLink = "_r9-0";
export var chatText = "_r9-1";